import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    ref={svgRef}
    {...props}
  >
    <circle cx={9} cy={9.2} r={5} fill="currentColor" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.359.175l1.022 1.173 1.528-.652a.456.456 0 01.612.287l.467 1.511 1.658.03a.457.457 0 01.444.51l-.184 1.574 1.503.705c.227.107.326.38.219.608-.205.427-.576.977-.827 1.4l1.089 1.26a.461.461 0 01-.083.674l-1.286.913.485 1.596a.458.458 0 01-.348.581l-1.542.309-.203 1.654a.458.458 0 01-.586.384l-1.504-.343-.854 1.428a.455.455 0 01-.663.132l-1.263-.947-1.36.955a.454.454 0 01-.657-.152l-.769-1.38-1.63.318a.457.457 0 01-.541-.436l-.141-1.548-1.616-.376A.46.46 0 011 11.75l.507-1.498L.18 9.247a.46.46 0 01-.033-.704l1.044-1.135L.388 5.95a.459.459 0 01.22-.644l1.444-.623-.144-1.662a.46.46 0 01.5-.497l1.535.021.54-1.577A.456.456 0 015.13.712l1.407.653L7.667.146a.455.455 0 01.693.03L8.359.174zm-4.094 8c-.605-.609.315-1.533.92-.925l2.038 2.048 3.569-3.976c.57-.637 1.536.236.965.874l-4.005 4.463a.649.649 0 01-.965.05L4.265 8.174z"
      clipRule="evenodd"
    />
  </Icon>
));
